// ABOUTME: Service for creating and deleting OOH campaigns via the backend API.
// ABOUTME: Uses fetch with Auth0 token to call the Express API campaign endpoints.
import { inject } from '@angular/core'
import { AuthenticationService } from 'app/services/auth.service'
import { environment } from '../../../../environments/environment'

export interface CreateCampaignPayload {
  start_date: string
  end_date: string
  poi_ids: string[]
  org_id: string
  delivery_name: string
  delivery_id: string
}

export async function createCampaign(
  auth: AuthenticationService,
  payload: CreateCampaignPayload,
): Promise<Record<string, unknown>> {
  const token = await auth.getAccessToken()

  const response = await fetch(
    `${environment.OOH_API_BASE_URL}/ooh/campaigns`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    },
  )

  if (!response.ok) {
    const body = await response.text()
    throw new Error(`Campaign creation failed (${response.status}): ${body}`)
  }

  return response.json()
}

export async function deleteCampaign(
  auth: AuthenticationService,
  campaignId: number,
): Promise<{ deleted: boolean }> {
  const token = await auth.getAccessToken()

  const response = await fetch(
    `${environment.OOH_API_BASE_URL}/ooh/campaigns`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ campaign_id: campaignId }),
    },
  )

  if (!response.ok) {
    const body = await response.text()
    throw new Error(`Campaign deletion failed (${response.status}): ${body}`)
  }

  return response.json()
}

export function injectCampaignCreation() {
  return inject(AuthenticationService)
}
